import { Link } from "react-router-dom";

const footerLinks = [
  { label: "电影", to: "/category/movie" },
  { label: "电视剧", to: "/category/tv" },
  { label: "动漫", to: "/category/anime" },
  { label: "综艺", to: "/category/variety" },
  { label: "影视资讯", to: "/news" },
  { label: "关于我们", to: "/about" },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 w-full bg-primary-950 text-background-100">
      <div className="mx-auto grid w-full max-w-[1280px] gap-8 px-4 py-12 md:px-8 md:py-14 lg:grid-cols-4">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-secondary-500 text-primary-950">
              <i className="ri-movie-2-fill text-xl"></i>
            </span>
            <span className="text-lg font-extrabold text-background-50">91影视</span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-primary-200">
            91影视为您提供最新电影、电视剧资源和丰富影视资讯，覆盖多类型影视作品，满足您的观影和信息需求。
            <br />
            本站影视播放功能尚未开放，当前为信息展示与影视资讯平台。
          </p>
          <div className="mt-5 flex items-center gap-3">
            {["ri-weibo-fill", "ri-wechat-fill", "ri-bilibili-fill", "ri-youtube-fill"].map((icon) => (
              <span
                key={icon}
                className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-800 text-primary-100 transition-colors hover:bg-secondary-500 hover:text-primary-950"
              >
                <i className={`${icon} text-lg`}></i>
              </span>
            ))}
          </div>
        </div>

        <div>
          <h3 className="text-sm font-semibold text-background-50">快速导航</h3>
          <ul className="mt-4 grid grid-cols-2 gap-2 text-sm">
            {footerLinks.map((item) => (
              <li key={item.to}>
                <Link to={item.to} className="text-primary-200 transition-colors hover:text-secondary-300">
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="text-sm font-semibold text-background-50">联系我们</h3>
          <ul className="mt-4 space-y-2.5 text-sm text-primary-200">
            <li className="flex items-center gap-2">
              <i className="ri-mail-line text-secondary-400"></i>
              support@91yingshi.com
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-customer-service-2-line text-secondary-400"></i>
              合作与反馈：bd@91yingshi.com
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-time-line text-secondary-400"></i>
              服务时间：每日 09:00 - 22:00
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-primary-800">
        <div className="mx-auto flex w-full max-w-[1280px] flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-primary-300 sm:flex-row md:px-8">
          <p>© 2025 91影视 · 本站数据为演示内容，不代表真实影视资源</p>
          <p>仅供学习与演示使用 · 请支持正版影视内容</p>
        </div>
      </div>
    </footer>
  );
}